import Query from '../utils/Query';
import moment from "moment";
import Session from "../models/Session";

const defaultFields = '*,session_structure.*';

export default class SessionService {

	static generate(params) {
		return Query.post('/items/session', params, {
			fields: '*,dataset.*,dataset.columns.*'
		}, false)
			.then(response => new Session(response.data));
	}

	static ping(hash, mode, token) {
		if (token) {
			return Query.get('/custom/session/' + hash + '/' + mode + '/' + token + '/ping');
		} else {
			return Query.get('/custom/session/' + hash + '/' + mode + '/ping');
		}
	}

	static verify(hash) {
		return Query.get('/custom/session/' + hash + '/verify');
	}

	static terminate(hash, token) {
		return Query.get('/custom/session/' + hash + '/' + token + '/terminate');
	}

	static getAll(userId, type = 'live', limit = 100) {
		type = type ? '&filter[type][in]=' + (Array.isArray(type) ? type.join(',') : type) : '';
		return Query.get('/items/session?limit=' + limit + type + (userId ? '&filter[end_date][nnull]]filter[owner]=' + userId + '&fields=' + defaultFields : '') + '&sort=-start_date')
			.then(response => response.data.map(item => new Session(item)));
	}

	static getAllByDate(userId, type = 'live', date, limit = 100) {
		const day = moment(date).startOf('day');
		type = type ? '&filter[type][in]=' + (Array.isArray(type) ? type.join(',') : type) : '';
		return Query.get('/items/session?limit=' + limit + type + (userId ? '&filter[end_date][nnull]]filter[owner]=' + userId + '&fields=' + defaultFields : '') + ('&filter[start_date][between]=' + day.utc().format() + ',' + day.add(1, 'day').utc().format()) + '&sort=-start_date')
			.then(response => response.data.map(item => new Session(item)));
	}

	static getAllBetween(userId, type = 'live', startDate, endDate, limit = 100) {
		const start = moment(startDate);
		const end = moment(endDate);
		type = type ? '&filter[type][in]=' + (Array.isArray(type) ? type.join(',') : type) : '';
		return Query.get('/items/session?limit=' + limit + type + (userId ? '&filter[end_date][nnull]]filter[owner]=' + userId + '&fields=' + defaultFields : '') + ('&filter[start_date][between]=' + start.utc().format() + ',' + end.utc().format()) + '&sort=-start_date')
			.then(response => response.data.map(item => new Session(item)));
	}

	static get(hash) {
		return Query.get('/items/session', {
			single: 1,
			fields: '*,strategy.*,component.*,dataset.*,dataset.columns.*',
			filter: {
				hash,
			}
		}).then(response => new Session(response.data));
	}
}
